import { preffixTestIds } from 'utility/e2e'

export const IPO_TEST_IDS = preffixTestIds('ipo')({
  ACTION: 'action',
})
